(function() {
  var lastProductList = [];

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
  }

  function initGA4Tracking() {
    if (typeof FilterApi !== 'undefined') {
      var originalAfterCall = FilterApi.afterCall;
      FilterApi.afterCall = function(result, eventType, eventInfo) {
        if (originalAfterCall) originalAfterCall.apply(this, arguments);

        try {
          if (result && result.products && result.products.length > 0) {
            lastProductList = result.products;
            var listId = boostPFSConfig.general.collection_id || 'search_results';
            var listName = boostPFSConfig.general.collection_handle || 'Search Results';

            var items = result.products.map(function(product, index) {
              var variant = product.variants && product.variants[0] ? product.variants[0] : {};
              return {
                item_id: 'shopify_US_' + product.id + '_' + (variant.id || ''),
                item_name: product.title,
                index: index + 1,
                item_brand: product.vendor,
                item_category: product.product_type || '',
                item_variant: variant.title || '',
                price: product.price / 100,
                item_list_id: listId,
                item_list_name: listName
              };
            });

            if (typeof gtag === 'function') {
              gtag('event', 'view_item_list', {
                item_list_id: listId,
                item_list_name: listName,
                items: items
              });
            }
          }
        } catch (e) {
          console.error('GA4 view_item_list error:', e);
        }
      };
    }

    document.addEventListener('click', function(event) {
      var productItem = event.target.closest('.boost-pfs-filter-product-item');
      if (productItem) {
        try {
          var productId = productItem.getAttribute('data-id');
          if (productId && lastProductList.length > 0) {
            var productData = lastProductList.find(function(p) { return p.id == productId; });
            if (productData) {
              var index = lastProductList.indexOf(productData);
              var variant = productData.variants && productData.variants[0] ? productData.variants[0] : {};
              var listId = boostPFSConfig.general.collection_id || 'search_results';
              var listName = boostPFSConfig.general.collection_handle || 'Search Results';

              var item = {
                item_id: 'shopify_US_' + productData.id + '_' + (variant.id || ''),
                item_name: productData.title,
                index: index + 1,
                item_brand: productData.vendor,
                item_category: productData.product_type || '',
                item_variant: variant.title || '',
                price: productData.price / 100,
                item_list_id: listId,
                item_list_name: listName
              };

              // Store list info in cookie for cross-page persistence (30 days)
              setCookie('ga4_last_list_id', listId, 30);
              setCookie('ga4_last_list_name', listName, 30);

              if (typeof gtag === 'function') {
                gtag('event', 'select_item', {
                  item_list_id: listId,
                  item_list_name: listName,
                  items: [item]
                });
              }
            }
          }
        } catch (e) {
          console.error('GA4 select_item error:', e);
        }
      }
    }, true);
  }

  // Wait for dependencies
  var checkDeps = setInterval(function() {
    if (typeof FilterApi !== 'undefined' && typeof boostPFSConfig !== 'undefined' && typeof gtag === 'function') {
      initGA4Tracking();
      clearInterval(checkDeps);
    }
  }, 500);
})();
